module.exports = __webpack_public_path__ + "static/media/connected-health.8280e2dd.png";